// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-cv-english-js": () => import("./../../../src/pages/cv-english.js" /* webpackChunkName: "component---src-pages-cv-english-js" */),
  "component---src-pages-cv-spanish-js": () => import("./../../../src/pages/cv-spanish.js" /* webpackChunkName: "component---src-pages-cv-spanish-js" */),
  "component---src-pages-english-js": () => import("./../../../src/pages/english.js" /* webpackChunkName: "component---src-pages-english-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

